import React, { Component, Fragment } from "react";
import { InfoBoard, InfoBoardHelper } from "./InfoBoard";
/**
 * InfoBoard 2 Arkmaterial
 */
class InfoBoard2 extends Component {
    initialValuesLoaded = false;

    handleProductionMarginOrientationChange = event => {
        let { value } = event.target;

        this.setState(
            { productionMarginDirection: value},
            this.handleBlur
        );
    };

    handleInput = (name, event) => {
        let { value } = event.target;

        if (event.target.value == "") {
            this.setState({
                [name]: ""
            });
            return;
        }

        this.setState({
            [name]: isNaN(value) ? value : parseFloat(value)
        });
    };

    handleBlur = () => {
        // width and height = material width and height
        // printWidth and printHeight = object to print
        let {
            height,
            width,
            printWidth,
            printHeight,
            bleed,
            printDirection,
            productionMargin,
            productionMarginDirection,
            objectSizeM2: lastRenderedSize
        } = this.state;

        let sheetSizeM2 = (width / 1000) * (height / 1000);
        bleed = typeof bleed == "undefined" || isNaN(bleed) ? 0 : parseFloat(bleed);

        if (parseInt(productionMargin) > 0 ) {
            if (productionMarginDirection == 'standing') {
                height -= productionMargin;
            } else {
                width -= productionMargin;
            }
        }

        let sheetFormat = width + 'x' + height;

        let wmm = parseFloat(printWidth) + bleed;
        let hmm = parseFloat(printHeight) + bleed;
        let objectSizeM2 = (wmm * hmm) / 1000000;
        let amountPerWidthStanding = 0;
        let amountPerHeightStanding = 0;
        let amountPerWidthLaying = 0;
        let amountPerHeightLaying = 0;
        let amountPerSheetStanding = 0;
        let amountPerSheetLaying = 0;
        let objectsPerRow = 0;

        if (isNaN(wmm) || isNaN(hmm)) return;

        if (hmm > 0 && wmm > 0) {
            amountPerWidthStanding = Math.floor(width / wmm);
            amountPerWidthLaying = Math.floor(height / wmm);
            amountPerHeightStanding = Math.floor(height / hmm);
            amountPerHeightLaying = Math.floor(width / hmm);
            amountPerSheetStanding =
                Math.floor(amountPerWidthStanding) *
                Math.floor(amountPerHeightStanding);

            amountPerSheetLaying =
                Math.floor(amountPerWidthLaying) *
                Math.floor(amountPerHeightLaying);
        }

        let circumference = parseFloat(
            (
                (printWidth + printWidth + printHeight + printHeight) /
                1000
            ).toFixed(4)
        );

        let circumferenceLaying =
            amountPerSheetLaying > 0
                ? parseFloat(
                    (
                        (amountPerSheetLaying *
                            (printWidth +
                                printWidth +
                                printHeight +
                                printHeight)) /
                        1000
                    ).toFixed(4)
                )
                : 0;
        let circumferenceStanding =
            amountPerSheetStanding > 0
                ? parseFloat(
                    (amountPerSheetStanding *
                        (printWidth +
                            printWidth +
                            printHeight +
                            printHeight)) /
                    1000
                ).toFixed(2)
                : 0;
        let totalM2Laying = parseFloat(
            parseFloat((amountPerSheetLaying * objectSizeM2).toFixed(4))
        );
        let totalM2Standing = parseFloat(
            parseFloat((amountPerSheetStanding * objectSizeM2).toFixed(4))
        );

        let usageLaying =
            totalM2Laying > 0
                ? Math.ceil((totalM2Laying / sheetSizeM2) * 100)
                : 0;
        let usageStanding =
            totalM2Standing > 0
                ? Math.ceil((totalM2Standing / sheetSizeM2) * 100)
                : 0;

        // Recalculate and remove decimals so we get a nicer output
        objectSizeM2 = parseFloat(parseFloat((wmm * hmm) / 1000000).toFixed(4));

        jQuery(
            ".js-totalCircumferenceStanding, .js-totalCircumferenceLaying"
        ).removeClass("js-totalCircumference");
        if (printDirection == "laying") {
            objectsPerRow = amountPerSheetStanding; // Yes, this is actually correct even though it looks to be reversed
            jQuery(".js-totalCircumferenceStanding").addClass(
                "js-totalCircumference"
            );
        } else {
            objectsPerRow = amountPerSheetLaying;
            jQuery(".js-totalCircumferenceLaying").addClass(
                "js-totalCircumference"
            );
        }

        if (
            this.initialValuesLoaded &&
            this.state.objectSizeM2 &&
            this.state.circumference &&
            (this.state.objectSizeM2 != objectSizeM2 || this.state.circumference != circumference)
        ) {
            this.clearDontRecalculateFlag = true;
        }

        this.setState(
            {
                objectSizeM2,
                objectsPerRow,
                amountPerWidthStanding,
                amountPerHeightStanding,
                amountPerWidthLaying,
                amountPerHeightLaying,
                amountPerSheetStanding,
                amountPerSheetLaying,
                circumference,
                circumferenceLaying,
                circumferenceStanding,
                totalM2Laying,
                totalM2Standing,
                usageLaying,
                usageStanding,
                lastRenderedSize,
                sheetFormat
            },
            () => {
                this.updateParent();
            }
        );
    };

    updateParent = () => {
        let { onChange } = this.props;
        const { data } = this.props;
        const { id } = data;
        const {
            objectSizeM2,
            objectsPerRow,
            quantity,
            lastRenderedSize
        } = this.state;

        if ("function" !== typeof onChange) {
            console.error("Missing function onChange");
            return false;
        }

        if (!this.initialValuesLoaded) {
            onChange(id, "quantity", quantity);
            this.initialValuesLoaded = true;
        } else {
            if (lastRenderedSize != objectSizeM2) {
                onChange(id, "quantity", objectSizeM2);
            }
        }

        onChange(id, "objectsPerRow", objectsPerRow);

        if (this.clearDontRecalculateFlag) {
            onChange(id, "clear_dont_recalculate_flag");
        }
    };

    populateData(data, extendedData) {
        if (extendedData.printHeight) {
            let printHeight = parseFloat(extendedData.printHeight);
            if (isNaN(printHeight)) {
                printHeight = 0;
            }
            data.printHeight = printHeight;
        }

        if (extendedData.printWidth) {
            let printWidth = parseFloat(extendedData.printWidth);
            if (isNaN(printWidth)) {
                printWidth = 0;
            }
            data.printWidth = printWidth;
        }

        if (extendedData.bleed) {
            let bleed = parseFloat(extendedData.bleed);
            if (isNaN(bleed)) {
                bleed = 0;
            }
            data.bleed = bleed;
        } else {
            data.bleed = 0;
        }

        if (extendedData.productionMargin) {
            let productionMargin = parseInt(extendedData.productionMargin);
            if (isNaN(productionMargin)) {
                if (this.props.isEditable) {
                    productionMargin = this.props.globalSettings.infoboard2DefaultProductionMargin;
                } else {
                    productionMargin = 0;
                }
                
            }
            data.productionMargin = productionMargin;
        } else {
            if (this.props.isEditable) {
                data.productionMargin = this.props.globalSettings.infoboard2DefaultProductionMargin;
            } else {
                data.productionMargin = 0;
            }
        }

        if (extendedData.printDirection) {
            data.printDirection = extendedData.printDirection;
        } else {
            data.printDirection = "laying";
        }

        if (extendedData.productionMarginDirection) {
            data.productionMarginDirection = extendedData.productionMarginDirection;
        } else {
            data.productionMarginDirection = "laying";
        }
    }

    renderFields = () => {
        const {
            printDirection,
            printHeight,
            printWidth,
            objectSizeM2,
            amountPerHeightLaying,
            amountPerHeightStanding,
            amountPerWidthLaying,
            amountPerWidthStanding,
            amountPerSheetLaying,
            amountPerSheetStanding,
            circumference,
            usageLaying,
            usageStanding,
            bleed,
            productionMargin,
            productionMarginDirection,
            sheetFormat  
        } = this.state;

        // Yes, this is correct although it looks reversed
        let objectsPerRow =
            printDirection == "laying"
                ? amountPerSheetStanding
                : amountPerSheetLaying;

        const { isEditable } = this.props;
        const showHelpTexts = this.props.globalSettings.showHelpTexts == 1;

        const marginRotationList = [
            {
                option: "Liggande",
                value: "laying"
            },
            {
                option: "Stående",
                value: "standing"
            }
        ];

        return (
            <Fragment>
                <div className="row">
                    <div className="col-9">
                        <div className="row">
                            <div className="col-12 inputFieldsHolder">
                                <div className="form-group mr-1">
                                    <label>Bas i mm</label>
                                    {isEditable &&
                                        InfoBoardHelper.renderTextInput({
                                            name: "printWidth",
                                            onChange: event =>
                                                this.handleInput("printWidth", event),
                                            onBlur: event => this.handleBlur(),
                                            value: printWidth,
                                            className:
                                                "form-control form-control-sm text-right"
                                        })}
                                    {!isEditable && (
                                        <input
                                            className="form-control form-control-sm text-right"
                                            disabled
                                            readOnly
                                            value={printWidth}
                                        />
                                    )}
                                </div>
                                <div className="form-group mr-1">
                                    <label>Höjd i mm</label>
                                    {isEditable &&
                                        InfoBoardHelper.renderTextInput({
                                            name: "printHeight",
                                            onChange: event =>
                                                this.handleInput("printHeight", event),
                                            onBlur: event => this.handleBlur(),
                                            value: printHeight,
                                            className:
                                                "form-control form-control-sm text-right"
                                        })}
                                    {!isEditable && (
                                        <input
                                            className="form-control form-control-sm text-right"
                                            disabled
                                            readOnly
                                            value={printHeight}
                                        />
                                    )}
                                </div>
                                <div className="form-group mr-1">
                                    <label>
                                        Beställd yta m<sup>2</sup>
                                    </label>
                                    <input
                                        className="form-control form-control-sm form-control-hilite text-right js-orderedAreaM2"
                                        value={objectSizeM2}
                                        disabled
                                    />
                                </div>
                                <div className="form-group mr-1">
                                    <label>Omkrets lpm</label>
                                    <input
                                        className="form-control form-control-sm form-control-hilite text-right js-totalCircumference"
                                        value={circumference}
                                        disabled
                                    />
                                </div>
                                <div className="form-group mr-1">
                                    <label>Utfall</label>
                                    {isEditable &&
                                        InfoBoardHelper.renderTextInput({
                                            name: "bleed",
                                            onChange: event =>
                                                this.handleInput("bleed", event),
                                            onBlur: event => this.handleBlur(),
                                            value: bleed,
                                            className:
                                                "form-control form-control-sm text-right"
                                        })}
                                    {!isEditable && (
                                        <input
                                            className="form-control form-control-sm text-right"
                                            disabled
                                            readOnly
                                            value={bleed}
                                        />
                                    )}
                                </div>
                                <div className="form-group mr-1 ml-4">
                                    {!isEditable && productionMarginDirection == 'laying' && (<label>Liggande marginal</label>)}
                                    {!isEditable && productionMarginDirection == 'standing' && (<label>Stående marginal</label>)}
                                    {!isEditable && (<input
                                                        className="form-control form-control-sm text-right"
                                                        disabled
                                                        readOnly
                                                        value={productionMargin}
                                                    />)}
                                    
                                    {isEditable && <label>Marginalplacering</label>}
                                    {isEditable && InfoBoardHelper.renderSelect(marginRotationList, {
                                                        name: "productionMarginDirection",
                                                        onChange: event =>
                                                            this.handleProductionMarginOrientationChange(event),
                                                        value: productionMarginDirection,
                                                        style: { width: "100px" }
                                                    })}
                                </div>
                                {isEditable && 
                                <div className="form-group mr-1">
                                    <label>Marginal</label>
                                    {isEditable &&
                                        InfoBoardHelper.renderTextInput({
                                            name: "productionMargin",
                                            onChange: event =>
                                                this.handleInput("productionMargin", event),
                                            onBlur: () => this.handleBlur(),
                                            value: productionMargin,
                                            className:
                                                "form-control form-control-sm text-right"
                                        })}
                                </div>}
                                <div className="form-group mr-1">
                                    <label>Materialets format</label>
                                    {<input
                                            className="form-control form-control-sm form-control-hilite text-right"
                                            disabled
                                            readOnly
                                            value={sheetFormat}
                                        />}
                                </div>
                            </div>
                        </div>
                        {((!isEditable && printDirection == "laying") ||
                            isEditable) && (
                                <div className="row">
                                    <div className="col-12 inputFieldsHolder">
                                        <div className="form-group mr-1">
                                            {!isEditable && (
                                                <React.Fragment>
                                                    <div className="form-group">
                                                        <label>Rotation</label>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            disabled
                                                            readOnly
                                                            value='Liggande'
                                                        />
                                                    </div>
                                                </React.Fragment>
                                            )}
                                            {isEditable && <label className="mt-1">&nbsp;</label>}
                                            {isEditable &&
                                                InfoBoardHelper.renderCheckbox("Liggande", {
                                                    name: "printDirectionLaying",
                                                    value: "laying",
                                                    checked:
                                                        printDirection == "laying"
                                                            ? "checked"
                                                            : "",
                                                    onClick: () => {
                                                        this.setState(
                                                            { printDirection: "laying" },
                                                            () => {
                                                                this.handleBlur();
                                                            }
                                                        );
                                                    }
                                                })}
                                        </div>
                                        <div className="form-group mr-1">
                                            <label>Antal/bas</label>
                                            <input
                                                className="form-control form-control-sm form-control-hilite text-right"
                                                value={amountPerWidthStanding}
                                                disabled
                                            />
                                        </div>
                                        <div className="form-group mr-1">
                                            <label>Antal/höjd</label>
                                            <input
                                                className="form-control form-control-sm form-control-hilite text-right"
                                                value={amountPerHeightStanding}
                                                disabled
                                            />
                                        </div>
                                        <div className="form-group mr-1">
                                            <label>Antal/ark</label>
                                            <input
                                                className="form-control form-control-sm form-control-hilite text-right"
                                                value={amountPerSheetStanding}
                                                disabled
                                            />
                                        </div>
                                        <div className="form-group mr-1">
                                            <label>Nyttjande i %</label>
                                            <input
                                                className="form-control form-control-sm form-control-hilite text-right"
                                                value={usageStanding}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                        {InfoBoardHelper.renderHiddenInput({
                            name: "infoboardType",
                            value: 2
                        })}

                        {InfoBoardHelper.renderHiddenInput({
                            name: "objectsPerRow",
                            value: objectsPerRow || 0
                        })}
                        {
                        (printDirection == 'standing' && 
                        InfoBoardHelper.renderHiddenInput({
                            name: "printDirection",
                            value: "standing"
                        }))
                        }
                        {
                        (printDirection == 'laying' && 
                        InfoBoardHelper.renderHiddenInput({
                            name: "printDirection",
                            value: "laying"
                        }))
                        }

                        {((!isEditable && printDirection == "standing") || isEditable) && (
                                <div className="row">
                                    <div className="col-12 inputFieldsHolder">
                                        <div className="form-group mr-1">
                                            {!isEditable && (
                                                <React.Fragment>
                                                    <div className="form-group">
                                                    <label>Rotation</label>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            disabled
                                                            readOnly
                                                            value='Stående'
                                                        />
                                                    </div>
                                                </React.Fragment>
                                            )}
                                            {isEditable && <label className="mt-1">&nbsp;</label>}
                                            {isEditable &&
                                                InfoBoardHelper.renderCheckbox("Stående", {
                                                    name: "printDirectionStanding",
                                                    value: "standing",
                                                    checked:
                                                        printDirection == "standing"
                                                            ? "checked"
                                                            : "",
                                                    onClick: () => {
                                                        this.setState(
                                                            { printDirection: "standing" },
                                                            () => {
                                                                this.handleBlur();
                                                            }
                                                        );
                                                    }
                                                })}
                                        </div>
                                        <div className="form-group mr-1">
                                            <label>Antal/bas</label>
                                            <input
                                                className="form-control form-control-sm form-control-hilite text-right"
                                                value={amountPerWidthLaying}
                                                disabled
                                            />
                                        </div>
                                        <div className="form-group mr-1">
                                            <label>Antal/höjd</label>
                                            <input
                                                className="form-control form-control-sm form-control-hilite text-right"
                                                value={amountPerHeightLaying}
                                                disabled
                                            />
                                        </div>
                                        <div className="form-group mr-1">
                                            <label>Antal/ark</label>
                                            <input
                                                className="form-control form-control-sm form-control-hilite text-right"
                                                value={amountPerSheetLaying}
                                                disabled
                                            />
                                        </div>
                                        <div className="form-group mr-1">
                                            <label>Nyttjande i %</label>
                                            <input
                                                className="form-control form-control-sm form-control-hilite text-right"
                                                value={usageLaying}
                                                disabled
                                            />
                                       </div>
                                    </div>
                                </div>
                            )}
                    </div>
                    <div className={(showHelpTexts ? "col-3" : "d-none")}>
                        <div className="helperTextBlock">
                            <p><b>Infoboard - Ark</b><br />
                                Mata in önskad storlek på objekten som ska produceras på arket.<br />
                                Välj utfall och rotation för maximalt nyttjande av arket.<br />
                                Vid mindre produktioner kan artiklar men infoboard Yta användas med manuellt spill.<br />
                                När objektet är större bör du beräkna manuellt hur många ark produktionen behöver.</p>
                            <p>Artiklar som du vill koppla till Infoboardsvärden dras in med flyttknappen.
                                Dra artikelraden till höger, den kopplas automatiskt till vald infoboardsdata och färgas grön.</p>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    };

    constructor(props) {
        super(props);
        const { data, extendedData } = this.props;

        // Populate with previously saved data
        if (
            Object.keys(extendedData).length === 0 &&
            extendedData.constructor === Object
        ) {
            // Nothing to load
            this.initialValuesLoaded = true;
        }

        this.populateData(data, extendedData);

        data.rows =
            extendedData.rows && extendedData.rows.length > 0
                ? extendedData.rows
                : [];

        this.state = data;
    }

    componentDidMount() {
        this.handleBlur();
    }

    render() {
        const { sortIndex } = this.props;
        InfoBoardHelper.sortIndex = sortIndex;

        return <InfoBoard>{this.renderFields()}</InfoBoard>;
    }
}

export default InfoBoard2;